export const MAPPING_STATUSES = [
  { label: 'Mapped by AI', value: 'mapped_by_ai', key: 1 },
  { label: 'Unmapped by AI', value: 'unmapped_by_ai', key: 2 },
  { label: 'AI Mapping Failed', value: 'ai_mapping_failed', key: 3 },
  { label: 'Mapped by User', value: 'mapped_by_user', key: 4 },
  { label: 'Failed Mail Deliveries', value: 'failed_mail_deliveries', key: 5 },
  { label: 'Originated in Lawft', value: 'originated_in_lawft', key: 6 },
];
